<template>
  <content-dialog
    :visible.sync="modalVisible"
    max-width="400px"
  >
    <template slot="dialogTitle">
      Comments
      <span v-if="title">
        {{ title }}
      </span>
    </template>

    <v-card-text
      class="pa-6"
      :class="{ 'text-xs-center': comments.loading }"
    >
      <!--<editor-fold desc="loader">-->
      <v-progress-circular
        v-if="comments.loading"
        :indeterminate="true"
        :size="50"
        :width="4"
        height="100px"
      />
      <!--</editor-fold>-->
      <v-list
        v-else
        three-line
      >
        <template v-for="(comment, i) in comments.data">
          <comment-tile
            :key="comment.id"
            :comment="comment"
            @edit:comment="editComment"
          />
          <v-divider
            v-if="i < comments.data.length - 1"
            :key="'divider-' + i"
            class="my-4"
          />
        </template>
      </v-list>
    </v-card-text>

    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Close
      </v-btn>
      <v-btn
        color="primary"
        @click="createComment"
      >
        <v-icon
          small
          left
        >
          edit
        </v-icon>
        Add new comment
      </v-btn>
    </template>

    <comment-edit-dialog
      :visible.sync="commentEditDialog"
      :comment="commentDirty"
      @comment:created="commentCreated"
      @comment:updated="commentUpdated"
      @comment:deleted="commentDeleted"
    />
  </content-dialog>
</template>

<script>
  import cloneDeep from 'lodash/cloneDeep'
  import Comment from '@/models/Comment'
  import ContentDialog from '@/components/helpers/Dialog'
  import CommentTile from '@/components/helpers/CommentListTile'
  import CommentEditDialog from '@/components/helpers/CommentEditDialog'

  export default {
    name: 'CommentsListDialog',
    components: {
      ContentDialog,
      CommentTile,
      CommentEditDialog
    },
    props: {
      visible: {
        type: Boolean,
        required: true
      },
      commentableType: {
        type: String,
        required: true
      },
      commentableId: {
        type: Number,
        required: true
      },
      title: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        commentDirty: cloneDeep(Comment.emptyModel),
        comments: {
          loading: false,
          data: []
        },
        commentEditDialog: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      },
      commentEmptyModel() {
        return {
          ...Comment.emptyModel,
          commentable_type: this.commentableType,
          commentable_id: this.commentableId
        }
      }
    },
    created() {
      this.fetchComments()
    },
    methods: {
      async fetchComments() {
        this.comments.loading = true

        let queryParams = {
          commentable_type: this.commentableType,
          commentable_id: this.commentableId
        }

        try {
          this.comments.data = await Comment.api.fetch(queryParams)
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.comments.loading = false
        }
      },
      openCommentEditDialog(comment) {
        this.commentDirty = cloneDeep(comment)
        this.commentEditDialog = true
      },
      editComment(comment) {
        this.openCommentEditDialog(comment)
      },
      createComment() {
        this.openCommentEditDialog(this.commentEmptyModel)
      },
      commentCreated(comment) {
        this.comments.data.unshift(comment)
      },
      commentUpdated(comment) {
        const index = this.comments.data.findIndex(b => b.id === comment.id)

        this.comments.data.splice(index, 1, comment)
      },
      commentDeleted(commentId) {
        const index = this.comments.data.findIndex(b => b.id === commentId)

        this.comments.data.splice(index, 1)
      }
    }
  }
</script>
